export class Table {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<Column>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Table.attributeTypeMap;
    }
    constructor() {
    }
}
